module.exports = __webpack_public_path__ + "static/media/bw.940ff709.webp";